<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger"
       [class.-is-open]="isPanelOpened"
       (click)="isPanelOpenedChange.emit(!isPanelOpened)">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Addresses section title@@customerOverviewComponent.heading.addresses'>Addresses</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">

          <button class="esf-button esf-button--simple" (click)="createAddress();$event.stopPropagation();" [edsTooltip]="tooltipTranslations.i18nCreateNewAddress">
            <svg class="esf-icon esf-button__icon" width="18" height="18">
              <use xlink:href="#esf-icon-circle-outlined-plus"></use>
            </svg>
            <span class="esf-button__icon-text"></span>
          </button>

        </span>
      </span>
    </h4>
  </div>
  <div class="esf-accordion__target" [hidden]="!isPanelOpened">
    <div class="esf-info-tile esf-info-tile--full-width">
      <div class="esf-info-tile__content">
        <table class="esf-table" *ngIf="currentAddresses?.length">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.addressType' data-label="Address type">
                <span i18n='Table cell heading@@general.tableCellLabel.addressType' class="esf-table__cell-inner">Address Type</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.street' data-label="Street">
                <span i18n='Table cell heading@@general.tableCellLabel.street' class="esf-table__cell-inner">Street</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.postCode' data-label="Post code">
                <span i18n='Table cell heading@@general.tableCellLabel.postCode' class="esf-table__cell-inner">Post code</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.city' data-label="City">
                <span i18n='Table cell heading@@general.tableCellLabel.city' class="esf-table__cell-inner">City</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.country' data-label="Country">
                <span i18n='Table cell heading@@general.tableCellLabel.country' class="esf-table__cell-inner">Country</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head esf-table__cell--no-label"></th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row esf-table__row--is-clickable" *ngFor="let address of currentAddresses; let i = index" (click)="editAddress(address)">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.addressType' data-label="Address type"
                  [ngClass]="{standard: address.type === 'standard', delivery: address.type === 'delivery', additional: address.type === 'additional'}">
                <span class="esf-table__cell-inner">{{ address.translatedType }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.street' data-label="Street">
                <!-- <span class="esf-tooltip esf-tooltip--top" [edsTooltip]="streetTooltip(address)">
                  <span class="esf-table__cell-inner">{{ address.street }}</span>
                </span> -->
                <span class="esf-table__cell-inner">{{ address.street }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.postCode' data-label="Post code">
                <span class="esf-table__cell-inner">{{ address.postalCode }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.city' data-label="City">
                <span class="esf-table__cell-inner">{{ address.city }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.country' data-label="Country">
                <ng-container *ngFor="let country of countries">
                  <span class="esf-table__cell-inner" *ngIf="country.iso2 === address.country">{{ country.name }}</span>
                </ng-container>
              </td>
              <td class="esf-table__cell">
                <span class="esf-table__cell-inner">
                  <button class="esf-button esf-button--simple"
                          (click)="deleteAddressModal(address.id);$event.stopPropagation();"
                          *ngIf="address.type !== 'standard'"
                          [edsTooltip]="tooltipTranslations.i18nDelete">
                    <svg class="esf-icon" width="16" height="16">
                      <use xlink:href="#esf-icon-trash"></use>
                    </svg>
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="esf-table" *ngIf="!currentAddresses?.length">
          <section class="esf-empty-state flex-empty-state">
            <div>
              <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
                <use xlink:href="#esf-icon-location"></use>
              </svg>
            </div>
            <p class="esf-paragraph"><small i18n='Text for empty state@@customerOverviewComponent.text.noAddresses'>There are no addresses yet.</small></p>
            <button class="esf-button esf-button--standard esf-button--filled esf-button--small" (click)="createAddress()">
              <svg class="esf-icon esf-button__icon" width="16" height="16">
                <use xlink:href="#esf-icon-plus"></use>
              </svg>
              <span class="esf-button__icon-text" i18n='Button for empty state@@customerOverviewComponent.button.addNewContact'>Add a new address</span>
            </button>
          </section>
        </table>

      </div>
    </div>
  </div>
</div>
